import { Component } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import { SessionService } from '../services/session.service';
import { AuthService } from '../auth/auth.service';
import { environment } from '../../environments/environment';
import { SharedService } from '../shared/shared.service';
import { GuestModalComponent } from '../buyer/guest-login/guest-modal/guest-modal.component';
import { NgIf } from '@angular/common';

@Component({
    selector: 'app-main-body',
    templateUrl: './main-body.component.html',
    styleUrls: ['./main-body.component.scss'],
    standalone: true,
    imports: [RouterOutlet, NgIf, GuestModalComponent]
})
export class MainBodyComponent {
  maintenanceModeOn = environment.maintenanceMode;

  constructor(
    public sessionService: SessionService,
    public auth: AuthService,
    public sharedService: SharedService,
    public router: Router,
    ) { }
}
